@if (showAllNotification()) {
  <section id="notify-msg-container">
    @if (success() && !permission_error()) {
      <div class="toast success">
        <i
          nz-icon
          class="inline-error-icon multicolorIcon"
          nzType="icons:check-circle-filled"
        ></i>
        <span>{{ i18n.langString("all_notification_successful_toast") }}</span>
      </div>
    }

    @if (permission_error()) {
      <div class="toast error">
        <i
          nz-icon
          class="inline-error-icon fillwhite"
          nzType="icons:error-exclamation-circle"
        ></i>
        <span>{{ i18n.langString("push_permission_denied") }}</span>
      </div>
    }
  </section>

  <div class="all-notification-container">
    <app-email-toggle
      [settings]="settings()"
      [loading]="loading()"
      [userEmail]="UserEmail()"
      [value]="allNotificationsEmailSelected()"
      (valueChange)="toggleAllEmail($event)"
      [allNotifications]="true"
    >
    </app-email-toggle>

    <app-push-notification-toggle
      [settings]="settings()"
      [loading]="loading()"
      [value]="allNotificationsPushSelected()"
      (valueChange)="toggleAllPush($event)"
      [allNotifications]="true"
      [reset]="resetTrigger()"
    >
    </app-push-notification-toggle>
  </div>
}

<nz-modal
  [nzVisible]="pushNotificationModalVisible()"
  (nzVisibleChange)="pushNotificationModalVisible.set($event)"
  (nzOnCancel)="closePushNotificationModal(false)"
  [nzFooter]="null"
  [nzCloseIcon]="'icons:exit'"
  [nzTitle]="i18n.langString('push_notification')"
>
  <div *nzModalContent>
    <p>{{ i18n.langString("push_notification_modal_text") }}</p>

    @if (!requestingNotificationPermission()) {
      <app-asset-nav-button
        (clickEvent)="requestNotificationPermission()"
        blackBG="true"
        [bypassConnectedStatus]="true"
      >
        {{ i18n.langString("always") }}
      </app-asset-nav-button>

      <app-asset-nav-button
        id="never-button"
        [bypassConnectedStatus]="true"
        (clickEvent)="closePushNotificationModal(false)"
      >
        {{ i18n.langString("never") }}
      </app-asset-nav-button>
    } @else {
      <app-spinner class="grant-permission-spinner"></app-spinner>
    }
  </div>
</nz-modal>

<nz-modal
  [nzVisible]="!!customAlertMessage()"
  (nzOnCancel)="closeCustomAlert()"
  [nzFooter]="null"
  [nzCloseIcon]="'icons:exit'"
  [nzTitle]="customAlertTitle() || undefined"
>
  <div *nzModalContent>
    @if (instructionsAddToHomeScreenIOS()) {
      <app-asset-nav-button
        (clickEvent)="customAlertMessage.set('')"
        blackBG="true"
        [bypassConnectedStatus]="true"
      >
        {{ i18n.langString("instructions") }}
      </app-asset-nav-button>
    }

    <app-asset-nav-button
      (clickEvent)="closeCustomAlert()"
      blackBG="true"
      [bypassConnectedStatus]="true"
    >
      {{ i18n.langString("okay") }}
    </app-asset-nav-button>
  </div>
</nz-modal>
